import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import BlockProse from "@/components/blocks/renderers/BlockProse";

/**
 * Sky-blue full-width call-to-action banner. Heading, body, and up to two
 * buttons. Any of the optional fields may be blank; buttons only render when
 * their label is present.
 */
export default function CtaBannerBlock({ data }) {
  const {
    heading,
    body,
    primary_label,
    primary_href,
    secondary_label,
    secondary_href,
    style = "light",
  } = data || {};

  const isDark = style === "dark";
  const sectionBg = isDark ? "bg-slate-900" : "bg-sky-600";
  const headingColor = isDark ? "text-white" : "text-white";
  const bodyColor = isDark ? "text-slate-400" : "text-sky-100";
  const primaryBtn = isDark
    ? "bg-sky-500 hover:bg-sky-400 text-white"
    : "bg-white text-sky-700 hover:bg-sky-50";
  const secondaryBtn = isDark
    ? "border-slate-600 text-slate-300 hover:bg-slate-800 hover:text-white"
    : "border-white/40 text-white hover:bg-sky-700";

  return (
    <section className={`${sectionBg} py-14 lg:py-16`}>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {heading && <h2 className={`text-2xl sm:text-3xl font-bold ${headingColor}`}>{heading}</h2>}
        {body && (
          <div className={`mt-3 max-w-lg mx-auto ${bodyColor}`}>
            <BlockProse
              value={body}
              proseClassName={`prose prose-sm max-w-lg mx-auto ${isDark ? "prose-p:text-slate-400 prose-a:text-sky-300" : "prose-p:text-sky-100 prose-a:text-white"} prose-a:underline`}
              plainClassName={`text-sm max-w-lg mx-auto whitespace-pre-line ${bodyColor}`}
            />
          </div>
        )}
        {(primary_label || secondary_label) && (
          <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-center">
            {primary_label && (
              <Link to={primary_href || "/contact"}>
                <Button className={`${primaryBtn} rounded-full px-8 h-12 text-sm font-semibold`}>
                  {primary_label} <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </Link>
            )}
            {secondary_label && (
              <Link to={secondary_href || "/contact"}>
                <Button
                  variant="outline"
                  className={`${secondaryBtn} rounded-full px-8 h-12 text-sm font-semibold`}
                >
                  {secondary_label}
                </Button>
              </Link>
            )}
          </div>
        )}
      </div>
    </section>
  );
}
